import OnlineScene from './scenes/OnlineScene';
import Phaser from 'phaser';
import { GAME_W, GAME_H } from './constants';
import BootScene from './scenes/BootScene';
import MainMenuScene from './scenes/MainMenuScene';
import { GameScene } from './scenes/GameScene';
import PauseScene from './scenes/PauseScene';
import GameOverScene from './scenes/GameOverScene';
import VictoryScene from './scenes/VictoryScene';

export const GameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_W,
  height: GAME_H,
  parent: 'app',
  backgroundColor: '#0a0a1a',
  antialias: true,
  roundPixels: false,
  scene: [
    BootScene,
    MainMenuScene,
    OnlineScene,
    GameScene,
    PauseScene,
    GameOverScene,
    VictoryScene,
  ],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_W,
    height: GAME_H,
  },
  input: {
    activePointers: 3,
    keyboard: true,
    mouse: true,
    touch: true,
    gamepad: true,
  },
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
    },
  },
  audio: {
    disableWebAudio: false,
  },
};
